import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import IconButton from "./iconButton";
import CustomModal from "./modal";
import Label from "./label";
import ICSelect from "./form/selectInput";
import { Button } from "reactstrap";
import RTPMWhiteIcon from "../assets/images/rtpm-icon-white.png";
import { STATE_LIST_SHORT } from "../constants/helperConstants";
import RTPMIcon from "../assets/images/RTPM-Icon.png";

const STATES = [
    { _id: "ACT", val: "ACT" },
    { _id: "NSW", val: "NSW" },
    { _id: "NT", val: "NT" },
    { _id: "QLD", val: "QLD" },
    { _id: "SA", val: "SA" },
    { _id: "TAS", val: "TAS" },
    { _id: "VIC", val: "VIC" },
    { _id: "WA", val: "WA" },];

const RTPMBtn = props => {

    const [okayBtnText, setOkayBtnText] = useState('');
    const [isRTPMModelOpen, setIsRTPMModelOpen] = useState(false);
    const [selectedState, setSelectedState] = useState(props.state);

    const openRTPMLink = () => {
        setIsRTPMModelOpen(!isRTPMModelOpen);
        switch (selectedState) {
            case 'QLD':
                window.open('https://hp.qscript.health.qld.gov.au/', "_blank");
                break;
            case 'ACT':
                window.open('https://hp.canberrascript.act.gov.au/', "_blank");
                break;
            case 'NSW':
                window.open('https://hp.safescript.health.nsw.gov.au/', "_blank");
                break;
            case 'NT':
                window.open('https://hp.ntscript.nt.gov.au/', "_blank");
                break;
            case 'SA':
                window.open('https://hp.scriptcheck.sa.gov.au/', "_blank");
                break;
            case 'TAS':
                window.open('https://hp.tasscript.health.tas.gov.au/', "_blank");
                break;
            case 'VIC':
                window.open('https://hp.safescript.vic.gov.au/', "_blank");
                break;
            case 'WA':
                window.open('https://hp.scriptcheck.health.wa.gov.au//', "_blank");
                break;
        }

    }

    const toggleRTPMModal = () => {
        setIsRTPMModelOpen(!isRTPMModelOpen);
    }

    const handleModalBtnState = (val) => {
        switch (val) {
            case 'QLD':
                setOkayBtnText('Open QScript QLD');
                break;
            case 'ACT':
                setOkayBtnText('Open CanberraScript ACT')
                break;
            case 'NSW':
                setOkayBtnText('Open SafeScripts NSW')
                break;
            case 'NT':
                setOkayBtnText('Open NTScript NT')
                break;
            case 'SA':
                setOkayBtnText('Open ScriptCheck SA')
                break;
            case 'TAS':
                setOkayBtnText('Open TasScript TAS')
                break;
            case 'VIC':
                setOkayBtnText('Open SafeScript VIC')
                break;
            case 'WA':
                setOkayBtnText('Open ScriptCheck WA')
                break;
            default:
                setOkayBtnText('Open QScript QLD');
        }
    }

    useEffect(() => {
        console.log("Got the state in RTPM: ", props.state);
        if (props.state) {
            setSelectedState(props.state);
            handleModalBtnState(props.state);
        }
    }, [props.state]);

    return (
        <>
            <img src={RTPMIcon} alt="RTPM-Icon" className="rtpm-icon-btn" onClick={toggleRTPMModal} />
            {/* <Button
                type={props.type}
                color="primary"
                className={`insta-button-primary insta-button-icon rtpm-btn-container ${props.className}`}
                onClick={toggleRTPMModal}
            >
                <img src={RTPMWhiteIcon} alt="rtpm-white-icon" className="custom-img-icon rtpm-btn" />
                <span className="insta-btn-span"> RTPM </span>
                <i className={"fas fa-external-link-alt external-link-icon"}></i>
            </Button> */}
            <CustomModal
                title="Real-Time Prescription Monitoring"
                noButtons={true}
                openModal={isRTPMModelOpen}
                cancelEvent={() => toggleRTPMModal()}
                child={
                    <>
                        <div className="w-100 text-left mb-3">
                            <Label className="gray ex-small" title="State" />
                            <ICSelect
                                id="state"
                                name="state"
                                items={STATE_LIST_SHORT}
                                useId="stateId"
                                useValue="stateId"
                                value={selectedState}
                                className="placeholder-small"
                                placeholder={selectedState}
                                handleChange={val => {
                                    console.log("Selected val?: ", val);
                                    setSelectedState(val);
                                    handleModalBtnState(val);
                                }}
                            />
                        </div>
                        <div className="w-100 text-center">
                            <button
                                className="insta-button-primary mt-2"
                                onClick={() => openRTPMLink()}
                            >
                                {okayBtnText}
                            </button>
                        </div>
                    </>
                }
            />
        </>
    )
};

export default RTPMBtn;

RTPMBtn.defaultProps = {
    state: "",
    className: ""
};

RTPMBtn.prototype = {
    state: PropTypes.string,
    className: PropTypes.string
};
